var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"mb-4"},'div',_vm.$attrs,false),_vm.$listeners),[_c('h1',{staticClass:"headline",domProps:{"textContent":_vm._s(_vm.text)}}),_c('div',{staticClass:"subheading",domProps:{"textContent":_vm._s(_vm.sub)}})])}
var staticRenderFns = []

export { render, staticRenderFns }